import React, { useState, useEffect, useRef } from 'react';
import { styled } from 'styled-components';

const DropdownContainer = styled.div`
    min-width: 350px;

    @media (max-width: 600px) {
        max-width: 100%;
    }
`;

const Dropdown = ({ options, label, setSelectedOption, selectedOption }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [internalSelectedMapped, setInternalSelectedMapped] = useState();
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const handleSelect = (option) => {
        setSelectedOption(option.value);
        setInternalSelectedMapped(option);
        setIsOpen(false);
    };

    useEffect(() => {
        if (selectedOption) {
            setInternalSelectedMapped(options.find((o) => o.value === selectedOption));
        }
    
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [options, selectedOption]);

    return (
        <DropdownContainer className="dropdown-container" ref={dropdownRef}>
            <div className="form-label fw-bold">
                {label}
            </div>
            <div className="dropdown">
                <button
                    className="btn btn-outline-secondary border-0 dropdown-toggle shadow-sm component-bg min-width-350"
                    onClick={toggleDropdown}
                >
                    {internalSelectedMapped?.text || label}
                </button>
                {isOpen && (
                    <div className="dropdown-menu show">
                        {options.map((option, index) => (
                            <button
                                key={index}
                                className="dropdown-item min-width-350"
                                onMouseDown={() => handleSelect(option)}
                            >
                                {option.text}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </DropdownContainer>
    );
};

export default Dropdown;
